module.exports = __webpack_public_path__ + "HYUNDAI-logo.png";